import React ,{useEffect,useState} from 'react'
import { useAuth } from "../../../usercontext";
import STopMenu from "../../student/topmenu/topmenu";
import S12TopMenu from "../topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import PageNotes from "../../pages/common/pagenotesnew";
import { getIdData } from "../../../lib/studentinfo";

export default function StudentFinAidIndex() {
  const { profile } = useAuth();
   const [studentInfo, setStudentInfo] = useState();
  const slug = profile.id;
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  const isStudent911 = profile?.role === "Student911";

  
    async function GetStudentData() {
        const std = await getIdData(slug);
        setStudentInfo(std);
        console.log("std", std);   
      }

useEffect(() => {
    GetStudentData();
}, [slug])

  return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="Financial Aid" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="Financial Aid" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="Financial Aid" />}
			<PageNotes type={'Student'} studentId={slug} />
			<div className="settings-widget profile-details">
				<div className="settings-inner-blk p-0">
					<div className="col-md-12 vh-100">
						{studentInfo &&
							(studentInfo[0].finaidlink !== null ? (
								<iframe
									style={{
										width: '100%',
										height: '100%',
										overflow: 'auto'
									}}
									src={studentInfo[0].finaidlink}
								></iframe>
							) : (
								<div className="d-flex justify-content-center">
									<h1 className="mt-5">Coming Soon</h1>
								</div>
							))}
					</div>
				</div>
			</div>
		</>
	)
}